/**
 * Validates a Brazilian CNPJ using check digit algorithm.
 */
export const validateCNPJ = (cnpj: string): boolean => {
  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(digits)) return false;

  // First check digit
  let sum = 0;
  let weight = 5;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(digits[i]) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  let remainder = sum % 11;
  const d1 = remainder < 2 ? 0 : 11 - remainder;
  if (parseInt(digits[12]) !== d1) return false;

  // Second check digit
  sum = 0;
  weight = 6;
  for (let i = 0; i < 13; i++) {
    sum += parseInt(digits[i]) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  remainder = sum % 11;
  const d2 = remainder < 2 ? 0 : 11 - remainder;
  return parseInt(digits[13]) === d2;
};

/**
 * Validates email format.
 */
export const validateEmail = (email: string): boolean => {
  const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return re.test(email.trim());
};

/**
 * Validates Brazilian phone (11 digits: DDD + 9 + number).
 */
export const validatePhone = (phone: string): boolean => {
  const digits = phone.replace(/\D/g, "");
  if (digits.length !== 11) return false;
  // DDD cannot start with 0
  if (digits[0] === "0") return false;
  // Mobile must start with 9
  if (digits[2] !== "9") return false;
  return true;
};

/**
 * Returns a validation message for a field, or null if valid/empty.
 */
export const getValidationMessage = (
  field: "cnpj" | "email" | "phone",
  value: string
): string | null => {
  if (!value || value.trim().length === 0) return null;

  switch (field) {
    case "cnpj": {
      const digits = value.replace(/\D/g, "");
      if (digits.length < 14) return "CNPJ incompleto";
      return validateCNPJ(value) ? null : "CNPJ inválido – verifique os dígitos";
    }
    case "email":
      return validateEmail(value) ? null : "E-mail inválido – verifique o formato (ex: nome@empresa.com)";
    case "phone": {
      const digits = value.replace(/\D/g, "");
      if (digits.length < 11) return "Telefone incompleto";
      return validatePhone(value) ? null : "Telefone inválido";
    }
  }
};
